import styles from "./UserReviews.module.scss";
import { HandySvg } from "handy-svg";

function ReviewItem({ title, name, location, body, dictionary }) {
	const starArr = new Array(5).fill(1);

	return (
		<div className={styles.review}>
			<header className={styles.header}>
				<div className={styles.avatar}>{name}</div>
				<div className={styles.accInfo}>
					<div className={styles.rating}>
						{starArr.map((_, idx) => (
							<HandySvg key={idx} src="/main_page/reviews/filled_star.svg" width="30" height="30" fill={"#6371DE"} />
						))}
					</div>
					<div className={styles.location}>
						<HandySvg width="24" height="24" src="/main_page/reviews/location_icon.svg" />
						{dictionary[location]}
					</div>
				</div>
			</header>
			<div className={styles.body}>
				<h4 className={styles["body-title"]}>{dictionary[title]}</h4>
				<p className={styles["body-text"]}>{body}</p>
			</div>
		</div>
	);
}

export default ReviewItem;
